module.exports = __webpack_public_path__ + "media/images/patient-icons/forms-icon-e2c07bf73bd824ab6899ef4d848296ab.svg";